module.exports = __webpack_public_path__ + "img/area-4-video3-cover.2c46182.jpg";